import React from 'react';
export function Footer() {
  return <footer className="w-full bg-bg-soft border-t border-line py-14 px-4" data-id="element-108">
      <div className="max-w-4xl mx-auto text-center" data-id="element-109">
        <div className="text-rose font-bold tracking-[0.18em] text-xs mb-3 uppercase" data-id="element-110">
          🌸 Aula Mater™
        </div>
        <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink mb-2 uppercase tracking-tight" data-id="element-111">
          Aula Mater
        </h3>
        <div className="font-serif-italic text-rose text-lg mb-4" data-id="element-112">
          Arte • Historia • Identidad • Tradición
        </div>
        <p className="text-ink-soft max-w-2xl mx-auto text-sm md:text-base leading-relaxed mb-8" data-id="element-113">
          Colección visual y educativa dedicada al arte del tatuaje japonés
          tradicional. Una biblioteca de referencia para amantes del irezumi, la
          cultura y la mitología japonesa.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-10 text-sm text-ink" data-id="element-114">
          <span className="flex items-center gap-2" data-id="element-115">
            📧{' '}
            <span className="font-medium select-all" data-id="element-116">
              soporteaulamater@gmail.com
            </span>
          </span>
          <span className="hidden sm:inline text-line" data-id="element-117">|</span>
          <span className="flex items-center gap-2" data-id="element-118">
            📲 Instagram:{' '}
            <span className="font-medium select-all" data-id="element-119">@aulamater_</span>
          </span>
          <span className="hidden sm:inline text-line" data-id="element-120">|</span>
          <span className="flex items-center gap-2" data-id="element-121">
            📘 Facebook:{' '}
            <span className="font-medium select-all" data-id="element-122">Aula Mater</span>
          </span>
        </div>

        <div className="border-t border-line pt-6 text-xs text-muted leading-relaxed max-w-2xl mx-auto" data-id="element-123">
          © {new Date().getFullYear()} Aula Mater™ — Todos los derechos
          reservados. Prohibida la reproducción y redistribución sin
          autorización expresa. Este material tiene fines educativos y
          coleccionables.
        </div>
        <div className="font-serif-italic text-rose text-base mt-6" data-id="element-124">
          🌸 "Algunas historias quedan grabadas en la piel."
        </div>
      </div>
    </footer>;
}